import { BuilderConfig } from '@/types/builder';

import RoomstayBlogCaseStudiesHero, { RoomstayBlogCaseStudiesHeroProps } from './roomstay-blog-case-studies-hero';

export const RoomstayBlogCaseStudiesHeroBuilderConfig = {
    name: 'Hero Case Studies',
    inputs: [
        {
            name: 'title',
            type: 'html',
        },
        {
            name: 'description',
            type: 'html',
        },
        {
            name: 'ctaButton',
            type: 'array',
            subFields: [
                {
                    name: 'text',
                    type: 'string',
                },
                {
                    name: 'sectionId',
                    type: 'string',
                },
                {
                    name: 'link',
                    type: 'string',
                },
            ],
        },
    ],
};

    const builderConfig: BuilderConfig<RoomstayBlogCaseStudiesHeroProps> = {
    component: RoomstayBlogCaseStudiesHero,
    config: RoomstayBlogCaseStudiesHeroBuilderConfig,
};

export default builderConfig;
